import React from "react";
import TextBlockEditor from "./editors/lesson/TextBlockEditor";
import HeadingBlockEditor from "./editors/lesson/HeadingBlockEditor";
import ImageBlockEditor from "./editors/lesson/ImageBlockEditor";
import CodeBlockEditor from "./editors/lesson/CodeBlockEditor";
import SingleChoiceBlockEditor from "./editors/lesson/SingleChoiceBlockEditor";
import MultipleChoiceBlockEditor from "./editors/lesson/MultipleChoiceBlockEditor";
import PlaceholderCodeEditor from "./editors/lesson/PlaceholderCodeEditor";

export default function BlockEditorPanel({ fragmentId, block, onChange, courseId }) {
    if (!fragmentId) return <div className="text-gray-500">یک فرگمنت انتخاب کن</div>;
    if (!block) return <div className="text-gray-500">یک بلاک انتخاب کن</div>;

    const set = (patch) => onChange(patch);

    return (
        <div>
            {block.type === "text" && <TextBlockEditor block={block} onChange={set} />}
            {block.type === "heading" && <HeadingBlockEditor block={block} onChange={set} />}
            {block.type === "image" && (
                <ImageBlockEditor block={block} onChange={set} courseId={courseId} />
            )}
            {block.type === "code" && <CodeBlockEditor block={block} onChange={set} />}

            {block.type === "question_single_choice" && (
                <SingleChoiceBlockEditor block={block} onChange={set} />
            )}

            {block.type === "question_multiple_choice" && (
                <MultipleChoiceBlockEditor block={block} onChange={set} />
            )}

            {block.type === "placeholder_code" && (
                <PlaceholderCodeEditor block={block} onChange={set} />
            )}
        </div>
    );
}
